







import { create } from "zustand";
 
const stored = JSON.parse(localStorage.getItem("notifications")) || [];
 
export const useNotificationStore = create((set) => ({
 
  notifications: stored,
  unreadCount: stored.length,
  chatUnreadCount: 0,
  activeChatId: null,
  activeGroupId: null,

  setActiveChat: (id) => set({ activeChatId: id }),
  setActiveGroup: (id) => set({ activeGroupId: id }),
 






  addNotification: (notification) =>
  set((state) => {
    const newNotification = {
      ...notification,
      created_at: notification.created_at || new Date().toISOString(), // ✅ ADD THIS
    };

    const updated = [newNotification, ...state.notifications];
    localStorage.setItem("notifications", JSON.stringify(updated));

    return {
      notifications: updated,
      unreadCount: state.unreadCount + 1,
    };
  }),



  // addNotification: (notification) =>
  //   set((state) => {
  //     const updated = [notification, ...state.notifications];
  //     localStorage.setItem("notifications", JSON.stringify(updated));
 
  //     return {
  //       notifications: updated,
  //       unreadCount: state.unreadCount + 1,
  //     };
  //   }),
 
  setChatUnreadCount: (count) => set({ chatUnreadCount: count }),
  incrementChatUnread: () => set((state) => ({ chatUnreadCount: state.chatUnreadCount + 1 })),
 
  removeNotification: (id) =>
    set((state) => {
      const updated = state.notifications.filter((n) => n.id !== id);
      localStorage.setItem("notifications", JSON.stringify(updated));
 
      return {
        notifications: updated,
        unreadCount:
          state.unreadCount > 0 ? state.unreadCount - 1 : 0,
      };
    }),
 
  clearUnread: () =>
    set(() => ({
      unreadCount: 0,
    })),
 
  clearAll: () => {
    localStorage.removeItem("notifications");
    set({ notifications: [], unreadCount: 0 });
  },
}));
 
 
 
 
 
 







// import { create } from "zustand";
 
// const stored = JSON.parse(localStorage.getItem("notifications")) || [];
 
// export const useNotificationStore = create((set) => ({
 
//   notifications: stored,
//   unreadCount: stored.length,
//   chatUnreadCount: 0,
//   activeChatId: null,
//   activeGroupId: null,

//   setActiveChat: (id) => set({ activeChatId: id }),
//   setActiveGroup: (id) => set({ activeGroupId: id }),
 
//   addNotification: (notification) =>
//     set((state) => {
//       const updated = [notification, ...state.notifications];
//       localStorage.setItem("notifications", JSON.stringify(updated));
 
//       return {
//         notifications: updated,
//         unreadCount: state.unreadCount + 1,
//       };
//     }),
 
//   setChatUnreadCount: (count) => set({ chatUnreadCount: count }),
//   incrementChatUnread: () => set((state) => ({ chatUnreadCount: state.chatUnreadCount + 1 })),
 
//   removeNotification: (id) =>
//     set((state) => {
//       const updated = state.notifications.filter((n) => n.id !== id);
//       localStorage.setItem("notifications", JSON.stringify(updated));
 
//       return {
//         notifications: updated,
//         unreadCount:
//           state.unreadCount > 0 ? state.unreadCount - 1 : 0,
//       };
//     }),
 
//   clearUnread: () =>
//     set(() => ({
//       unreadCount: 0,
//     })),
 
//   clearAll: () => {
//     localStorage.removeItem("notifications");
//     set({ notifications: [], unreadCount: 0 });
//   },
// }));
 
 
 
 
 
 

